module.exports = __webpack_public_path__ + "img/logomidi.c16ee01e.png";